import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { MTable, MCard, MSpinner } from "components/Shared";
import { getCaseHazards as getCaseHazardsRequest } from "requests/homeowner/ho";
import { createRequestCoalescer } from "tools/requestCoalescer";

const caseHazardsCoalescer = createRequestCoalescer();
const activeRequest = { current: true };

const CaseHazards = (props) => {
  const { controlNumber } = props;

  let mounted = useRef(true);
  const [caseHazards, setCaseHazards] = useState(null);
  const [isFetchingCaseHazards, setIsFetchingCaseHazards] = useState(false);

  useEffect(() => {
    if (!controlNumber) return undefined;

    mounted.current = true;
    setIsFetchingCaseHazards(true);
    const unsubscribe = caseHazardsCoalescer.run(
      controlNumber,
      (resolve, reject) => getCaseHazardsRequest(controlNumber, resolve, activeRequest, reject),
      (response) => {
        if (mounted.current) {
          setCaseHazards(response);
          setIsFetchingCaseHazards(false);
        }
      },
      () => {
        if (mounted.current) {
          setCaseHazards([]);
          setIsFetchingCaseHazards(false);
        }
      },
    );

    return () => {
      mounted.current = false;
      unsubscribe();
    };
  }, [controlNumber]);

  let hazLevels = [];
  if (caseHazards) {
    caseHazards.forEach(s => {
      if (!hazLevels[s.hazardLevel])
        hazLevels[s.hazardLevel] = [s];
      else
        hazLevels[s.hazardLevel].push(s);
    });
  }

  const GetData = (hazardList) => {
    return hazardList.map(s => ({
      placeholder: "",
      category: s.hazardCategory.categoryName,
      count: s.hazardCount,
      subCategory: s.hazardCategory.subcategoryName,
      details: s.details
    }
    ));
  };

  const GroupHazards = (hazardList) => {
    let lastCategory = "";
    let returnList = [];
    for (let i = 0; i < hazardList.length; i++) {
      if (hazardList[i].category == lastCategory) {
        hazardList[i].category = "";
        hazardList[i].count = "";
        returnList.push(hazardList[i]);
      }
      else {
        lastCategory = hazardList[i].category;
        returnList.push(hazardList[i]);
      }
    }
    return returnList;
  };

  const GetDistinctCount = (hazardLevelGroup) => new Set(hazardLevelGroup.map(x => x.hazardCategory.categoryName)).size;

  const getHazardSummaryFields = () => {
    if (isFetchingCaseHazards || !caseHazards) {
      return <MSpinner />;
    }
    if (caseHazards && !caseHazards.length) {
      return <div>No Hazards</div>;
    } else {
      let hazardTables = [];
      for (let s in hazLevels) {
        let i = hazLevels[s];
        hazardTables.push(
          <MTable
            key={s}
            columnDefinitions={[
              { name: `${s}: ${GetDistinctCount(i)}`, dataSource: "category", style: { width: "30%" } },
              { name: "Subcategory", dataSource: "subCategory", style: { width: "45%" } },
              { name: "Details", dataSource: "details", style: { width: "25%" } },
            ]}
            data={GroupHazards(GetData(i))}
          />
        );
      }
      return hazardTables;
    }
  };

  return (
    <MCard
      title="Hazard Summary"
      className="qa-case-hazards">
        {getHazardSummaryFields()}
    </MCard>
  );
};

CaseHazards.propTypes = {
  controlNumber: PropTypes.number,
};

export default CaseHazards;